import { t } from '@lingui/core/macro';
import { Box, Skeleton, pxToRem } from '@pocketlaw/tetris';
// TODO: This needs to be moved / Refactored
import { useDesktopNavigation } from 'app/domains/common-ui/components/PageLayout/components/DesktopNavigation';
import { useMobileNavigation } from 'app/domains/common-ui/components/PageLayout/components/MobileNavigation';
import { LayoutToggleButton } from './LayoutToggleButton';
import { useScreenLayout } from './ScreenLayoutProvider';
import useMobile from '../hooks/useMobile';
import { TopbarContainer, TopbarDivider } from './styled';
export function Topbar(props) {
    const { breadcrumbs, actions } = props;
    const isMobile = useMobile();
    const { open } = useMobileNavigation();
    const { setMinimized, minimized } = useDesktopNavigation();
    const { state } = useScreenLayout();
    const handleMenuToggle = () => {
        if (isMobile) {
            open();
        }
        else {
            setMinimized(!minimized);
        }
    };
    const openTooltip = t({
        message: 'Open menu',
        comment: 'Screen layout - Open menu button tooltip',
    });
    const closeTooltip = t({
        message: 'Close menu',
        comment: 'Screen layout - Close menu button tooltip',
    });
    const menuTooltip = minimized ? openTooltip : closeTooltip;
    return (<TopbarContainer>
      <Box alignItems="center">
        <LayoutToggleButton side="left" tooltip={menuTooltip} open={!minimized} onClick={handleMenuToggle}/>
      </Box>

      {breadcrumbs && (<Skeleton loading={state === 'loading'} style={{ minWidth: pxToRem(200) }}>
          <TopbarDivider $side="left"/>
          {breadcrumbs}
        </Skeleton>)}

      {actions && state !== 'error' && (<Box ml="auto" alignItems="center" style={{ flexShrink: 0 }} gap="md">
          <Skeleton loading={state === 'loading'}>{actions}</Skeleton>
        </Box>)}
    </TopbarContainer>);
}
